import script from "./QPageTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./QPageTitle.vue?vue&type=script&setup=true&lang=ts"

import "./QPageTitle.vue?vue&type=style&index=0&id=5c2c189a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2c189a"]])

export default __exports__